let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!dropdownLoaded) {
      window.BAO.sectionRenderer
        .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
        .then(res => {
          dropdownLoaded = true

          const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
          const myself = newDOM.querySelector(this.localName)

          this.outerHTML = myself.outerHTML
        })
        .catch(() => {})
    }

    this.setupListeners()
  }

  setupListeners () {
    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        itemEl.addEventListener('focusin', this.onFocusIn.bind(this))
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
      })
    }

    if (this.externalEls?.close?.exists) {
      this.externalEls.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
        closeEl.addEventListener('mouseenter', this.onClose.bind(this))
      })
    }

    if (this.els?.['banner-link']?.exists) {
      this.addEventListener('click', this.onMouseClick.bind(this))
    }
  }

  onMouseClick (e) {
    const targetEl = e.target.closest(this.els.item.selector)

    if (!targetEl) return

    const drawerOpen = document.body.classList.contains(
      '.lyt-Site-desktopMenuOpen',
    )

    if (drawerOpen !== true) {
      this.onOpen(targetEl)
    }
  }

  onOpen (targetEl) {
    document.body.classList.add(this.config.classes.menuActiveClass)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        itemEl.setAttribute('aria-expanded', itemEl === targetEl)
      })
    }
  }

  onFocusIn (e) {
    document.body.classList.add(this.config.classes.menuActiveClass)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        itemEl.setAttribute('aria-expanded', itemEl === e.currentTarget)
      })
    }
  }

  onClose () {
    window.setTimeout(() => {
      document.body.classList.remove(this.config.classes.menuActiveClass)
    }, 200)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        itemEl.setAttribute('aria-expanded', false)
      })
    }
  }

  get config () {
    return {
      classes: {
        menuActiveClass: 'lyt-Site-desktopMenuOpen',
      },
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
